/**
 * RESPONSIBILITY: draw one ministry as a card that opens its page.
 *
 * Home shows a few and the index shows them all, from the one list — so the card is one
 * component, and the link is derived from the row's identity rather than its position.
 *
 * IT MARKS ITSELF, for the reason given on EventCard: every list is filtered
 * `canEdit || isShown`, so a switched-off ministry reaching a card at all is proof that
 * whoever is looking may edit it.
 */
import type { Ministry } from '@app/sections';
import { Picture } from '../commons/Picture';
import { Page, hrefFor } from '../commons/pages';
import { keyOf } from '../commons/slug';
import { isShown } from '../commons/shown';
import { NotPublic } from '../commons/NotPublic';

export function MinistryCard({ m }: { m: Ministry }) {
  const off = !isShown(m);

  // No box round it: the photograph IS the card, and the words sit under it. The small
  // gold arrow says the whole thing is a way in; the title turns gold with it on hover.
  return (
    <a className={off ? 'min-card is-draft' : 'min-card'} href={m.href || hrefFor(Page.Ministry, keyOf(m))}>
      <Picture value={m.image} alt="" className="min-card-pic" />
      <div className="min-card-body">
        <div className="min-card-head">
          <h3>{m.title}</h3>
          <svg className="min-card-go" width="15" height="15" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
               aria-hidden="true" focusable="false">
            <path d="M7 17 17 7M8 7h9v9" />
          </svg>
        </div>
        {off && <NotPublic />}
        {m.blurb && <p>{m.blurb}</p>}
      </div>
    </a>
  );
}
